import { render, staticRenderFns } from "./mover.vue?vue&type=template&id=68b12459&"
import script from "./mover.vue?vue&type=script&lang=js&"
export * from "./mover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports